const VERSION_PATTERN = /^\d+(?:\.\d+)*$/;

/**
 * Orders dotted numeric versions segment by segment, so "1.10" is newer than "1.9" and "1.0"
 * equals "1.0.0". Returns a negative number, zero or a positive number like a sort comparator,
 * or `null` when either side is not a dotted numeric version.
 *
 * Mirrors `app/api/src/app-version/compare-versions.ts`, which enforces the same minimum; the two
 * must agree.
 */
export function compareVersions(a: string, b: string): number | null {
	if (!VERSION_PATTERN.test(a) || !VERSION_PATTERN.test(b)) {
		return null;
	}

	const left = a.split('.').map(Number);
	const right = b.split('.').map(Number);
	for (let i = 0; i < Math.max(left.length, right.length); i++) {
		const difference = (left[i] ?? 0) - (right[i] ?? 0);
		if (difference !== 0) {
			return Math.sign(difference);
		}
	}
	return 0;
}

/** False whenever either side is missing or unreadable: a bad value must never lock anyone out. */
export function isOlderThan(version: string, target: string | null | undefined): boolean {
	if (!target) {
		return false;
	}
	const comparison = compareVersions(version, target);
	return comparison !== null && comparison < 0;
}
